import { ProtectedImg } from '../../utils/protectedFile';
import {useState, useEffect} from 'react';
import { searchOnEnter } from '../../components/searchOnEnter';
import { Table, Modal, DropdownButton, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import MetaData from '../../layouts/MetaData';
import Loader from '../../layouts/Loader';
import { getHrLists, HRDeactivate, HRActivate } from '../../actions/adminActions';
import { useDispatch, useSelector} from 'react-redux';
import { useAlert } from 'react-alert';
import adminImg from '../../assets/Images/defaultUser.png';
import { HIDE_ALERT_MESSAGE } from '../../constants/Common';
import { Prod01 } from '../../constants/ActionType';
import { formatClinicianName } from '../../utils/clinicianName';
import { useSortableTable, SortableTh, personName } from '../../components/SortableTable';
import { formatDob } from '../../utils/dateFormat';

const HR_SORT_COLUMNS = {
    name: { type: 'name', value: personName },
    dob: { type: 'date', value: (h) => h?.DOB },
    gender: { type: 'string', value: (h) => h?.gender },
    provider: { type: 'name', value: (h) => personName(h?.assigned_doctor_id) },
    status: { type: 'boolean', value: (h) => h?.block },
};


const hrRoleLabel = (r) => r === 'HrLead' ? 'Lead Nurse' : r === 'HrMedical' ? 'Nurse' : r === 'HrNonMedical' ? 'Non-Medical' : r;

const HRList = () => {

    const dispatch = useDispatch();
    const alert = useAlert();
    const { loading, error, hrs } = useSelector(state => state.hrslist);
    const {message, error: hrUpdateError } = useSelector(state => state.common);

    const [smShow, setSmShow] = useState(false); //small confirm modal
    const [HRModel, setHRModel] = useState(null);
    const [HRToDelete, setHRToDelete] = useState(null);
    const tableSort = useSortableTable(hrs, { id: 'admin.nurses', columns: HR_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });
    const [hrIsBlocked, setHrIsBlocked] = useState(false);
    const [query, setQuery] = useState(""); // set search query.
    const keys = ["firstname", "lastname", "email", "DOB", "gender"];

    useEffect(() =>{
        if(error){
            alert.error(error);

            dispatch({
                type: HIDE_ALERT_MESSAGE
              })
        }

        if(hrUpdateError){
            alert.error(hrUpdateError);

            dispatch({
                type: HIDE_ALERT_MESSAGE
              })

        }

        if(message){
            alert.success(message);
            setSmShow(false);
            dispatch(getHrLists());

            dispatch({
                type: HIDE_ALERT_MESSAGE
              })
        }

        dispatch(getHrLists());

    }, [dispatch, error, message, hrUpdateError]);

    const deActivateHR = () => {
        dispatch(HRDeactivate(HRModel));
    }

    const activateHR = () => {
        dispatch(HRActivate(HRModel));
    }
    

  return <>
        <MetaData title="Nurse Resource"/>
                <Sidebar />    

                <section className="home-section">
                {/* TopBar */}
                <TopBar />

                {loading ? <Loader /> : ( <>
                    <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded">
                    <div className="home-content">

                        <div className="row-display">
                            <h5 style={{color: '#004aad'}}>
                                <i className='bx bx-plus-medical'></i> <strong>&nbsp;List of Nurses </strong>
                            </h5>

                            <div className="row-display"> 
                                    <Link to="/adminDashboard" className="btn btn-secondary pt-2"><i className='bx bx-arrow-back' ></i></Link> &nbsp;
                                    &nbsp;&nbsp;
                                    <Link to="/addhr" className="edit-pill">Add New Nurse</Link>
                            </div>
                        </div>
                        <hr />

                        <div className="container">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="row-display">    
                                        <input type="text" 
                                            placeholder="Search..." 
                                            className="form-control"
                                            onChange={e => setQuery(e.target.value)}
                                            onKeyDown={searchOnEnter(setQuery)}
                                        />
                                        &nbsp;&nbsp;&nbsp;

                                    </div>
                                </div>

                                <div className="col-md-9">
                                   
                                </div>
                            </div>
                        </div>
                        <br />


                        {/* HRs List */}
                        <div className="col-md-12">
                         <>
                         <Table className="table table-sm table-striped">
                            <thead align="center">
                                <tr>
                                <th>Nurse</th>    
                                <SortableTh sortKey="name" sort={tableSort}>Name</SortableTh>
                                <SortableTh sortKey="dob" sort={tableSort}>D.O.B</SortableTh>
                                <SortableTh sortKey="gender" sort={tableSort}>Gender</SortableTh>
                                <SortableTh sortKey="provider" sort={tableSort}>Nurse For</SortableTh>
                                <SortableTh sortKey="status" sort={tableSort}>Account Status</SortableTh>
                                <th>Consent Program</th>
                                <th>Action</th>
                                </tr> 
                            </thead>
                            
                            <tbody>
                            {tableSort.rows.filter(item => keys.some(key => item[key]?.toLowerCase().includes(query))).map((hr, index) => (
                               <tr key={index}>
                                
                                <td>
                                {hr?.profileImg ? <div>
                                    <ProtectedImg fileName={hr?.profileImg} 
                                    width="50" height="50" className="roundedBorderImg" />
                                </div> :  
                                <div>
                                    <img src={adminImg} width="50" height="50" className="roundedBorderImg" />
                                </div>
                                }
                                </td>

                                <td><Link className="link" to={{ pathname: "/hrProfile", state: {hr: hr}}}> {hr?.lastname}, {hr?.firstname} <p style={{color: 'gray'}}>({hrRoleLabel(hr?.role)})</p> </Link></td>
                                
                                <td>{formatDob(hr?.DOB)}</td>      
                                
                                {hr?.gender === 'male' ? <td>
                                    Male
                                    </td> : <td>Female
                                </td>}    
                                
                                {hr?.assigned_doctor_id ? <td style={{ color: '#23408e'}}>
                                    {formatClinicianName(hr?.assigned_doctor_id)} 
                                    </td> : 
                                <td>--</td>}

                                <td>
                                   {hr?.block === false ? <span style={{color: 'green', fontWeight: 'bold'}}>Active</span> : <span style={{color: 'red', fontWeight: 'bold'}}>Deactivated</span>}
                                </td>

                                <td>
                                    {hr?.consentRole === 'RPM' ? <b>RPM</b> : hr?.consentRole === 'CCM' ? <b>CCM</b> : <b>RPM & CCM</b>}
                                </td>
                                
                                {/* Actions Dropdown */}
                                <td>
                                        <DropdownButton id="dropdown-basic-button" variant="Light">
                                            <Dropdown.Item>
                                                <Link to={{ pathname: "/hrProfile", state: {hr: hr}}} className="link">View Profile</Link>
                                            </Dropdown.Item>

                                            <Dropdown.Item>
                                                <Link to={{ pathname: "/updateHR", state:{ hr: hr}}} className="link">Edit Details</Link>
                                            </Dropdown.Item>

                                            <Dropdown.Item>
                                                {hr?.block === false ? 
                                                <Link to="/hrlist" style={{color: 'red'}} className="link" onClick={() => {setSmShow(true); setHRModel(hr?._id); setHrIsBlocked(false); setHRToDelete(hr?.lastname)}}>Deactivate Profile</Link> : 
                                                <Link to="/hrlist" className="link" style={{color: 'green'}} onClick={() => {setSmShow(true); setHRModel(hr?._id); setHrIsBlocked(true); setHRToDelete(hr?.lastname)}}>Reactivate Profile</Link> }
                                            </Dropdown.Item>
                                        </DropdownButton>
                                    </td>
                                {/* Actions Dropdown ends*/}
                               </tr> 
                            ))}
                            
                            </tbody>
                        </Table>
                        </>
                        </div>

                      </div>
                    </div>
                </> 
                )}
                </section>

                <Modal
                size="sm"
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Body>
                    <small style={{color: 'gray'}}>{hrIsBlocked ? 'Reactivate this profile' : 'Deactivate this profile'}
                        <span style={{color: '#000'}}> (HR. {HRToDelete})</span>? {hrIsBlocked ? 'The person will be able to log in again.' : 'The person will no longer be able to log in.'}
                    </small>
                </Modal.Body>

                <Modal.Footer>
                    {hrIsBlocked
                        ? <button className="btn btn-sm btn-success" onClick={activateHR}>Reactivate Profile</button>
                        : <button className="btn btn-sm btn-danger" onClick={deActivateHR}>Deactivate Profile</button>}
                </Modal.Footer>
            </Modal>  
    </>
};

export default HRList;
